import template from './hueb-seo-canoncial.html.twig';

const { Component, Mixin, Store } = Shopware;
const { Criteria } = Shopware.Data;
const { mapVuexState, mapVuexGetters } = Shopware.Component.getComponentHelper();

Component.register('hueb-seo-canonical', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('placeholder')
    ],

    computed: {
        isLoading: () => Store.get('swOrderDetail').isLoading,
        richSnippets: () => Store.get('huebSeoProductDetail').richSnippets,
        parentRichSnippets: () => Store.get('huebSeoProductDetail').parentRichSnippets,
    },

    data() {
        return {
            configRepository: null,
            active: true,
            optionsItemCondition: null,
            optionsAvailability: null,
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {}
    }
});
